// extracted by mini-css-extract-plugin
module.exports = {"photo":"index-photo-1j4ir"};